// frontend/src/stores/selectedShip.js
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'

export const useSelectedShipStore = defineStore('selectedShip', () => {
  const selectedShip = ref(null)
  const selectedShipMmsi = ref(null)
  const selectedFrom = ref(null)
  const lastSelectedTime = ref(null)

  const hasSelectedShip = computed(() => !!selectedShipMmsi.value)
  const getSelectedShip = computed(() => selectedShip.value)

  function selectShip(ship, source = 'sidebar') {
    if (!ship) {
      clearSelection()
      return
    }
    
    // Validasi ship memiliki data yang diperlukan
    if (!ship.mmsi) {
      console.warn('Cannot select ship: missing MMSI', ship)
      return
    }
    
    // Clone ship data to avoid reactivity issues
    const shipData = {
      ...ship,
      // Ensure consistent property names
      name: ship.name || ship.ship_name || 'Unknown',
      mmsi: String(ship.mmsi),
      lat: ship.lat || ship.position_lat,
      lng: ship.lng || ship.position_lng,
      sog: ship.sog || ship.speed || 0,
      cog: ship.cog || ship.course || 0,
      heading: ship.heading || ship.hdg || 0,
      timestamp: ship.timestamp || ship.ts || new Date().toISOString(),
      callSign: ship.callSign || ship.call_sign || null,
      type_code: ship.type_code || ship.ship_type || null,
      navStat: ship.navStat || ship.nav_status || null,
      dest: ship.dest || ship.destination || null,
      eta: ship.eta || null
    }
    
    selectedShip.value = shipData
    selectedShipMmsi.value = shipData.mmsi
    selectedFrom.value = source
    lastSelectedTime.value = new Date().toISOString()
    
    // Optional: Emit event for global listeners
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('ship-selected', { 
        detail: { ship: shipData, source } 
      }))
    }
  }

  function clearSelection() {
    const oldMmsi = selectedShipMmsi.value
    selectedShip.value = null
    selectedShipMmsi.value = null
    selectedFrom.value = null
    lastSelectedTime.value = null
    
    // Emit clear event
    if (typeof window !== 'undefined') {
      window.dispatchEvent(new CustomEvent('ship-cleared', { 
        detail: { previousMmsi: oldMmsi } 
      }))
    }
  }

  function isShipSelected(mmsi) {
    if (!mmsi || !selectedShipMmsi.value) return false
    return String(selectedShipMmsi.value) === String(mmsi)
  }

  function updateSelectedShipPosition(lat, lng, sog, cog, heading) {
    if (selectedShip.value) {
      if (lat !== undefined) selectedShip.value.lat = lat
      if (lng !== undefined) selectedShip.value.lng = lng
      if (sog !== undefined) selectedShip.value.sog = sog
      if (cog !== undefined) selectedShip.value.cog = cog
      if (heading !== undefined) selectedShip.value.heading = heading
      
      // Update timestamp
      selectedShip.value.timestamp = new Date().toISOString()
    }
  }

  return {
    selectedShip,
    selectedShipMmsi,
    selectedFrom,
    lastSelectedTime,
    hasSelectedShip,
    getSelectedShip,
    selectShip,
    clearSelection,
    isShipSelected,
    updateSelectedShipPosition
  }
})